import type { SVGProps } from "react"

const Permissions = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 349.999 350" {...props}>
    <defs>
      <clipPath id="prefix__a">
        <path data-name="Rectangle 1588" transform="translate(792.67)" fill="none" d="M0 0h349.999v350H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 4062" transform="translate(-792.67)" clipPath="url(#prefix__a)">
      <path
        data-name="Path 41492"
        d="M967.67 109.5a65.5 65.5 0 1065.5 65.5 65.574 65.574 0 00-65.5-65.5m0 129.5a64 64 0 1164-64 64.073 64.073 0 01-64 64"
        fill="#98a300"
      />
      <path
        data-name="Path 41493"
        d="M999.17 146.5h-9.353l-8.786-11h-26.722l-8.785 11h-9.354a10 10 0 00-10 10v41.848a10 10 0 0010 10h63a10 10 0 0010-10V156.5a10 10 0 00-10-10m-31.023 44.377a14 14 0 1113.976-14 14 14 0 01-13.976 14m30.438-27.077a4.643 4.643 0 01-3.279 1.446h-.114a4.7 4.7 0 01-4.772-4.61v-.065a4.751 4.751 0 118.165 3.228"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 41494"
        d="M968.147 162.875a14 14 0 1013.977 14 14 14 0 00-13.977-14m0 26.5a12.5 12.5 0 1112.477-12.5 12.5 12.5 0 01-12.477 12.5"
        fill="#98a300"
      />
      <path
        data-name="Path 41495"
        d="M995.129 155.749a4.79 4.79 0 00-4.709 4.825v.066a4.7 4.7 0 004.772 4.609h.114a4.646 4.646 0 003.279-1.445 4.752 4.752 0 00-3.456-8.054m2.373 7.016a3.154 3.154 0 01-2.228.983 3.2 3.2 0 01-3.354-3.125v-.049a3.251 3.251 0 115.582 2.191"
        fill="#98a300"
      />
    </g>
  </svg>
)
export { Permissions }
